module.exports = __webpack_public_path__ + "img/medidas.29dd9a52.png";